import { Config } from './constants'
import { enqueue } from './core'
import { Events, Category } from './constants'

const SESSION_KEY = 'tracker_session'

function generateSessionId() {
  const ts = Date.now().toString(36)
  const rand = Math.random().toString(36).substring(2, 10)
  return `${ts}-${rand}`
}

function readSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch { return null }
}

function writeSession(session) {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session))
  } catch { /* 静默 */ }
}

export function getOrCreateSession() {
  const session = readSession()
  if (session && (Date.now() - session.lastActivity < Config.SESSION_TIMEOUT)) {
    return session
  }
  if (session) {
    endSession(session)
  }
  return startNewSession()
}

function startNewSession() {
  const session = {
    id: generateSessionId(),
    startTime: Date.now(),
    lastActivity: Date.now(),
    pageCount: 0,
    eventCount: 0,
  }
  writeSession(session)
  enqueue({
    eventName: Events.SESSION_START,
    eventCategory: Category.AUTO,
    eventParams: {
      session_id: session.id,
      referrer: document.referrer || '',
      landing_page: window.location.hash.replace('#', '') || window.location.pathname,
    },
  })
  return session
}

function endSession(session) {
  enqueue({
    eventName: Events.SESSION_END,
    eventCategory: Category.AUTO,
    eventParams: {
      session_id: session.id,
      duration_ms: Date.now() - session.startTime,
      page_count: session.pageCount,
      event_count: session.eventCount,
    },
  })
}

export function getSessionId() {
  const session = getOrCreateSession()
  return session.id
}

export function touchSession() {
  try {
    const session = readSession()
    if (!session) return
    if (Date.now() - session.lastActivity >= Config.SESSION_TIMEOUT) {
      getOrCreateSession()
      return
    }
    session.lastActivity = Date.now()
    session.eventCount++
    writeSession(session)
  } catch { /* 静默 */ }
}

export function incrementPageCount() {
  try {
    const session = readSession()
    if (session) {
      session.pageCount++
      session.lastActivity = Date.now()
      writeSession(session)
    }
  } catch { /* 静默 */ }
}

export function endCurrentSession() {
  try {
    const session = readSession()
    if (session) {
      endSession(session)
      sessionStorage.removeItem(SESSION_KEY)
    }
  } catch { /* 静默 */ }
}
